import React, { useCallback, useEffect, useState } from 'react';
import { useAssetContext } from '../../context/AssetContext';
import { LoaderType } from '../../loaders/Asset3DLibrary';
import { Dict } from '../../utils/Dict';


import maskImage from '../../assets/images/Fraunhofer-DarkModeSpheres_masked.jpg';
import sendIcon from '../../assets/images/icons/send.svg';
import sendGrayIcon from '../../assets/images/icons/send-gray.svg';
import greenTick from '../../assets/images/icons/green-tick.svg';
import menuCloseIcon from '../../assets/images/icons/menu-close.svg';
import downArrowIcon from '../../assets/images/icons/down-arrow.svg';
import hoverIcon from '../../assets/images/icons/masked-image-hover-icon.svg';

declare const window: any;
interface PreloaderProps {
    children: JSX.Element | JSX.Element[]
    assets?: Dict<AssetDef | string>
}

export type AssetDef = {
    filename: string,
    loader?: LoaderType
}

export default function Preloader({ children, assets }: PreloaderProps): JSX.Element
{
  const lib = useAssetContext();
  const [ loading, setLoading ] = useState(true);
  const [ progress, setProgress ] = useState(0);

  const onComplete = useCallback(() => {
    setLoading(false);
  }, []);

  const onError = useCallback((/*err?: ErrorEvent*/) => {
    // console.log(err);
  }, []);

  const onProgress = useCallback(p => {
    setProgress(Math.ceil(p * 100));
  }, []);

  useEffect(() => {
    // on reload, do not reload
    if (lib.expectedNumAssets > 0) return;

    lib.onComplete.bind(onComplete);
    lib.onError.bind(onError);
    lib.onProgress.bind(onProgress);

    if (assets) {
      for (const id in assets) {
        const a = assets[id];

        if (typeof a === 'string')
          lib.load(id, a);
        else
          lib.load(id, a.filename, a.loader);

        ++lib.expectedNumAssets;
      }
    }

    lib.waitForCompletion();

    return () => {
      lib.onComplete.unbind(onComplete);
      lib.onError.unbind(onError);
      lib.onProgress.unbind(onProgress);
    };
  }, [lib, onComplete, onError, onProgress, assets]);

  useEffect(() => {
    const images = [
      maskImage,
      sendIcon,
      sendGrayIcon,
      greenTick,
      menuCloseIcon,
      downArrowIcon,
      hoverIcon
    ];
    window.preloadedImages = [];
    images.forEach((image, i) => {
      const newImage = new Image();
      newImage.src = image;
      window.preloadedImages[i] = newImage;
    });
  }, []);

  if (loading) {
    return <div style={{position: 'absolute', width: '100vw', height: '100%', color: 'black', margin:'0', padding: '0'}} >
      <div style={{fontFamily: 'Nexa', fontWeight: 900, opacity: 0}}>_</div>
      <div style={{fontFamily: 'Nexa', fontWeight: 900, opacity: 0}}>_</div>

      <div style={{position: 'fixed', bottom: '0', width: progress + '%', height: '12px', background: '#fabb33'}}  />
    </div>;
  }
  else return <>{children}</>;
}
